import React, {useEffect, useState} from "react";
import n3 from "../../images/n3.jpg";
import ImageBox from "../../components/Image";
import CommonTitle from "../../components/common-title";
import {useParams} from "react-router-dom";
import {getUserEducations, getUserWorks, postResumesDetail} from "../../service";
import {EducationData, ResumesData, WorksData} from "../types";
import {sexTsf} from "../../units";
import Empty from "../../components/empty";
import MakePhoneCall from "../../components/makePhoneCall";
import usePhones from "../../routers/usePhones";
import {useLoading} from "../../components/loading/LoadingProvider";

const list = ['中国地区','港澳台地区','其他国家']
const stars = ['普通会员','一星管家','二星管家','三星管家','首席大管家']

function setP(content:string){
    return content.split(/[\r\n]/).map(item => <p>{ item.replace(/\s/g,'') }</p>)
}

function PeopleDetail() {

    const { id } = useParams<{ id:string }>()
    const [info,setInfo] = useState<ResumesData>()
    const [works,setWorks] = useState<Array<WorksData>>([])
    const [educations,setEducations] = useState<Array<EducationData>>([])
    const [cover,setCover] = useState<boolean>(false)
    const phones = usePhones()
    const loading = useLoading()

    useEffect(() => {
        postResumesDetail({
            resumeId:id,
        }).then(res => {
            if(res.code === 1){
                setInfo(res.data)
                const userId = res.data.customerId

                getUserWorks({
                    userId
                }).then(res => {
                    if(res.code === 1 ){
                        setWorks(res.data)
                    }
                })

                getUserEducations({
                    userId
                }).then(res => {
                    if(res.code === 1 ){
                        setEducations(res.data)
                    }
                })

            }else{
                loading.showError(res.msg)
            }
        })

    },[id])

    return <div className="job-detail">
        <div className="people-detail">
            <div className="bgImg">
                <img src={ n3 } />
            </div>
            <div className="top">
                <div className="img-box">
                    <ImageBox src={ info?.photo } height={ 150 }/>
                </div>
                <div className="text">
                    <h3>{ info?.fullName}</h3>
                    {/*<p className="d">女士</p>*/}
                    {/*<p className="d">1992-04-18 | 中国地区</p>*/}
                    <p className="t">国际职业管家联盟认证编号</p>
                    <p className="n">{ info?.authNumber }</p>
                    {/*<p className="t">管家星级</p>*/}
                    {/*<p className="n">一星</p>*/}
                </div>
                <div className="text2">
                    <div className="text2-box">
                        <p>性别</p>
                        <p>{ info && sexTsf(info.sex) }</p>
                    </div>
                    <div className="text2-box">
                        <p>出生日期</p>
                        <p>{ info?.birthday || '未知' }</p>
                    </div>
                    <div className="text2-box">
                        <p>国家</p>
                        <p>{ info?.region ? list[info.region] : '中国地区' }</p>
                    </div>
                    <div className="text2-box">
                        <p>管家星级</p>
                        <p>{ info?.stars ? stars[info.stars] : '普通会员' }</p>
                    </div>
                </div>
            </div>
            <div className="wrapper marginTop">
                <CommonTitle title={"个人优势"}/>
                <div className="content">
                    { info?.skill && setP(info.skill) }
                </div>
            </div>
            {/*<div className="space"/>*/}
            <div className="wrapper">
                <CommonTitle title={"教育经历"}/>
                <div className="lists">
                    {
                        educations.map((item,index) => {
                            return  <div className="item" key={index}>
                                <h2>{ item.school }</h2>
                                <p className="d">{ item.start } - { item.end } · { item.subject }</p>
                                <p className="x">学历：{ item.degree }</p>
                            </div>
                        })
                    }
                    {
                        educations.length === 0 && <Empty>用户没有填写教育经历</Empty>
                    }
                </div>
            </div>
            {/*<div className="space"/>*/}
            <div className="wrapper">
                <CommonTitle title={"工作经历"}/>
                <div className="lists">
                    {
                        works.map((item,index) => {
                            return  <div className="item" key={index}>
                                <h2>{ item.company.replace(/\s/g,'') }</h2>
                                <p className="d">{ item.start } - { item.end } · { item.post }</p>
                                <div className="x xxx">
                                    <h4 style={{ marginBottom:'3px',fontSize:'.26rem' }}>工作内容:</h4>
                                    { setP(item.content) }
                                </div>
                            </div>
                        })
                    }
                    {
                        works.length === 0 && <Empty>用户没有填写工作经历</Empty>
                    }
                </div>
            </div>
            <div className="detail-btn" onClick={() => setCover(true)}>雇佣管家</div>
        </div>
        {/*<div className="space"/>*/}

        {/*<div className="space"/>*/}

        {/*<div style={{ height:'1rem' }}>*/}
        {/*    <div className="common-fixed">*/}
        {/*        <div className="common-btn" style={{ backgroundColor:'#14D1B7' }}>*/}
        {/*            <p>我要雇佣</p>*/}
        {/*        </div>*/}
        {/*    </div>*/}
        {/*</div>*/}
        <MakePhoneCall show={ cover } telephone={ phones[7] } onClose={() => setCover(false)}/>
    </div>
}

export default PeopleDetail;
